module.exports = __webpack_public_path__ + "img/home-icon-4-1.f4af66b8.png";